import React, { useState, useEffect } from 'react';
import { Button, StyleSheet, TextInput, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import Modal from '../../../../components/Modal';
import BottomSheet from '../../../../components/BottomSheet';
import Input from '../../../../components/Forms/Input';
import { useForm } from 'react-hook-form';
import IconButton from '../../../../components/IconButton';
import api from '../../../../utils/api';
import { useToast } from 'react-native-toast-notifications';
import useFormSubmit from '../../../../hooks/useFormSubmit';



export default function NewUnitModal({ onRequestClose, onUnitCreated, communityId }) {
  const { control, handleSubmit } = useForm();

  const {submitForm, isSubmitting} = useFormSubmit({
    onSuccess: onUnitCreated,
    onError: (error) => {},
    successToastMessage: "Vivienda creada",
    endpoint: `/communities/${communityId}/units`,
  })



  return (
    <BottomSheet onRequestClose={onRequestClose} visible={true} height={310}>
      <View style={tw`pt-5 px-5`}>
        <Text style={tw`mb-4 text-lg font-600 text-secondary`}>Registrar vivienda</Text>

        <View style={tw``}>
          <Text style={tw`text-gray-500`}>Calle</Text>
          <Input control={control} name='street_name' rules={{required:true}} />
        </View>

        <View style={tw`row gap-x-3`}>
          <View style={tw`flex-1`}>
            <Text style={tw`text-gray-500`}>No. Exterior</Text>
            {/* keyboardType="numeric"  */}
            <Input control={control} name='external_number' rules={{required:true}} />
          </View>

          <View style={tw`flex-1`}>
            <Text style={tw`text-gray-500`}>No. Interior</Text>
            {/* keyboardType="numeric"  */}
            <Input control={control} name='internal_number' />
          </View>
        </View>

        <IconButton
          disabled={isSubmitting}
          title={"Guardar"}
          style={tw`self-end`}
          onPress={handleSubmit(submitForm)}
        />
      </View>
    </BottomSheet>
  );
}
